import { API_ENDPOINT, GetHeaders } from "./api";

export const getCarouselMessages = async (userId) => {
  try {
    const { headers } = await GetHeaders(true); // Obtém os headers com autenticação

    const response = await fetch(
      `${API_ENDPOINT}/message/getCarouselMessages?userId=${userId}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `Erro ao buscar mensagens do carrossel: ${response.status} - ${errorDetails.message}`
      );
    }

    return await response.json();
  } catch (err) {
    console.error("Erro ao buscar mensagens do carrossel:", err.message);
    return {
      success: false,
      error: true,
      message: err.message || "Erro ao buscar mensagens do carrossel",
    };
  }
};

export const saveStatusMessage = async (payload) => {
  try {
    const formData = new FormData();
    formData.append("type", payload.type);
    formData.append("payload", JSON.stringify(payload.payload));

    const { headers } = await GetHeaders(true);
    delete headers["Content-Type"]; // Deixe o navegador definir automaticamente

    const response = await fetch(`${API_ENDPOINT}/alert/saveStatusMessage`, {
      method: "POST",
      body: formData,
      headers,
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `Erro ao salvar mensagem visualizada: ${response.status} - ${errorDetails.message}`
      );
    }

    return await response.json();
  } catch (err) {
    console.error("Erro ao salvar o status da mensagem:", err);
    return {
      error: true,
      message: err.message || "Erro ao salvar o status da mensagem",
    };
  }
};
